import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=48a3a986"
import script from "./Speed.vue?vue&type=script&lang=js"
export * from "./Speed.vue?vue&type=script&lang=js"
import style0 from "./Speed.vue?vue&type=style&index=0&id=48a3a986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports